export const DEPARTING = 'departing';
export const RETURNING = 'returning';

export const DEPART_DATE = 'departDate';
export const RETURN_DATE = 'returnDate';

export const NEXT = 'next';
export const PREVIOUS = 'previous';
export const MONTH = 'month';

export const LIST_VIEW = 'LIST_VIEW';
export const CALENDAR_VIEW = 'CALENDAR_VIEW';

export const RAIDERS = 'RAIDERS';

export const tripTypeValues = {
  ONEWAY: 'ONEWAY',
  ROUNDTRIP: 'ROUNDTRIP',
};

export const WARNING_DEPARTING_AFTER_RETURNING =
  'warningDepartingAfterReturning';

export const FLIGHT_UNAVAILABLE = 'Unavailable';
export const FLIGHT_AVAILABLE = 'Available';

export const GA4_MAX_PAYLOAD_LIMIT = 8192;

export const DEFAULT_FARE_NAME = 'DF';
export const PREMIUM_FARE_NAME = 'PR';
export const BASIC_BUNDLE_TIER = 1;
export const BONUS_BUNDLE_TIER = 2;
export const TOTAL_BUNDLE_TIER = 3;
export const NEW_FARE_TIER = 4;
export const ALLEGIANT_FIRST = 'AllegiantFirst';
export const MAIN = 'Main';

export const BASIC_BUNDLE = 'Allegiant Basic Bundle';
export const BONUS_BUNDLE = 'Allegiant Bonus Bundle';
export const TOTAL_BUNDLE = 'Allegiant Total Bundle';
export const MAIN_BUNDLE_LIST = {
  [BASIC_BUNDLE]: 'BAF',
  [BONUS_BUNDLE]: 'BOF',
  [TOTAL_BUNDLE]: 'TOF',
}
export const ALLEGIANT_FIRST_BUNDLE = 'Allegiant First';
export const ALLEGIANT_FIRST_NAME = 'First';

export const eventTypes = {
  SELECT_FLIGHT: 'select_flight',
  LIST_VIEW: 'list_view',
  ADD_TO_CART: 'add_to_cart',
  REMOVE_FROM_CART: 'remove_from_cart',
  NO_BUNDLE_SELECTED: 'no_bundle_selected',
};
